/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const CREATE_ACTION_GROUP = gql`
  mutation CreateActionGroup($input: ActionGroupInput!) {
    createActionGroup(data: $input) {
      id
      title
    }
  }
`
